import React, { useCallback } from 'react';

import { SearchOutlined, UserOutlined } from '@ant-design/icons';
import { Image } from 'antd';

import defaultImage from '~/assets/default-user-image.png';
import { extractRequestError } from '~/helpers/error-helper';
import useAxios from '~/hooks/use-axios';
import colors from '~/values/colors';

import styles from './CheckinRecognitionTable.module.scss';
import IconButton from './IconButton';
import Table from './Table';

const { Column } = Table;

const tableScroll = { x: 500 };

const identifyAction = 4;

const SelectPerson = ({
    personId, eventId, reloadEventsList, api, onSelectPerson,
}) => {

    const handleIdentify = useCallback(async () => {
        try {
            const { data } = await api.post('/EventResponse/InsertEventResponseForManagement', {
                newPersonId: personId,
                action: identifyAction,
                recognitionEventId: eventId,
            });

            const updatedEvent = { ...data.recognitionEvent, action: data.action };

            reloadEventsList([updatedEvent]);
        } catch (err) {
            extractRequestError(
                err,
                'Não foi possível identificar a pessoa. Por favor, tente novamente.',
            );
        }
    }, [api, eventId, personId, reloadEventsList]);

    if (eventId) {
        return (
            <IconButton
                onClick={handleIdentify}
                title="Identificar pessoa"
                color={colors.link}
                Icon={SearchOutlined}
            />
        );
    }

    if (onSelectPerson) {
        return (
            <IconButton
                // eslint-disable-next-line react/jsx-no-bind
                onClick={() => onSelectPerson(personId)}
                title="Selecionar pessoa"
                color={colors.link}
                Icon={UserOutlined}
            />
        );
    }

    return (
        <IconButton
            to={`/app/people/${personId}`}
            Icon={UserOutlined}
            title="Selecionar pessoa"
            color={colors.link}
        />
    );
};

const CheckinRecognitionTable = ({
    dataSource, eventId, reloadEventsList, onSelectPerson,
}) => {
    const api = useAxios();

    const renderAvatar = useCallback(avatar => {
        const imageSource = avatar || defaultImage;

        return (
            <Image
                height={50}
                width={50}
                className={styles.avatar}
                alt="foto da pessoa"
                src={imageSource}
            />
        );
    }, []);

    const renderSimilarity = useCallback(similarity => {
        return similarity ? `${(similarity * 100).toFixed(1)}%` : null;
    }, []);

    const renderSelectPerson = useCallback((_, record) => {
        const { personId } = record;

        return (
            <SelectPerson
                api={api}
                personId={personId}
                eventId={eventId}
                reloadEventsList={reloadEventsList}
                onSelectPerson={onSelectPerson}
            />
        );
    }, [api, eventId, reloadEventsList, onSelectPerson]);

    return (
        <Table
            dataSource={dataSource}
            scroll={tableScroll}
            rowKey="personId"
        >
            <Column
                title="Foto"
                dataIndex="base64"
                render={renderAvatar}
            />
            <Column
                title="Nome"
                dataIndex="name"
            />
            <Column
                title="Similaridade"
                dataIndex="similarity"
                render={renderSimilarity}
            />
            <Column
                title={eventId ? 'Identificar' : 'Selecionar'}
                render={renderSelectPerson}
            />
        </Table>
    );
};

export default CheckinRecognitionTable;
